import React from 'react';

function SwitchItem({ id, isActive, handler }) {
    return (
        <li
            className={`switch-item ${isActive ? 'active' : ''}`}
            onClick={handler}
            onMouseEnter={handler}
        >
            <span>{id}</span>
        </li>
    );
}
export default SwitchItem;